import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Document} from '../../../../document/shared/classes/document';
import {DocumentService} from '../../../../document/shared/services/document.service';
import {DomSanitizer} from '@angular/platform-browser';
import { TRANSLATE } from '../../../classes/translatable';
import { AlertService } from '../../../services/alert.service';

@Component({
  selector: 'app-documents-table-input',
  templateUrl: './documents-table-input.component.html',
  styleUrls: ['./documents-table-input.component.css']
})
export class DocumentsTableInputComponent implements OnInit {
  @Input()  documents: Document[] = [];
  @Input()  isDeleteAllowed = false;
  @Output() deleteDoc = new EventEmitter();
  @Output() deleteEvent = new EventEmitter<Document>();

  public  displayedColumns: string[] = ['file', 'action'];
  public  selectedFile: Document = new Document();
  public  dataLocalUrl: any;

  constructor(
      private documentService: DocumentService,
      private sanitizer: DomSanitizer,
      private alertService: AlertService
  ) { }

  ngOnInit() {
  }

  downloadFile(document: Document) {
    this.documentService.getPublicUrl(document.file_name).subscribe(response => {
      if (response.status === 200) {
        this.dataLocalUrl = '';
        this.selectedFile = new Document(document);
        this.selectedFile.url = response.data;
        this.dataLocalUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.selectedFile.url);
      } else {
        this.alertService.warn(TRANSLATE(response.message));
      }
    });
  }

  onDialogFileClose() {
    this.selectedFile = new Document();
  }
}
